import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
  Container,
  Difficulty,
  QuestionLabel,
  Instructions,
  RangeRadio,
  RangeRadioContainer,
  Ranges,
  Label,
} from './styles';

class RangeQuestionType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: null,
    };
  }

  componentDidMount() {
    this.answerQuestion();
  }

  answerQuestion = (touched = false) => {
    const { question, onQuestionAnswered } = this.props;
    const { id: questionId, questionOptions } = question;

    const { answer } = this.state;

    let questionOptionId = null;
    let valueInteger = null;
    let error = null;

    if (answer) {
      const { id, label } = _.find(questionOptions, { id: answer });

      questionOptionId = id;
      valueInteger = parseInt(label, 10);
    } else {
      error = 'Please select an option before proceeding.';
    }

    onQuestionAnswered({
      questionId,
      questionOptionId,
      valueInteger,
      error,
      touched,
    });
  }

  onRangeRadioContainerClicked = (value) => () => {
    this.setState({
      answer: value,
    }, () => {
      this.answerQuestion(true);
    });
  }

  render() {
    const { question } = this.props;
    const { answer } = this.state;

    const questionOptions = _.sortBy(
      question.questionOptions,
      (option) => parseInt(option.label, 10),
    );

    return (
      <Container>
        <QuestionLabel>{question.label}</QuestionLabel>

        <Ranges>
          {questionOptions.map((option) => (
            <RangeRadioContainer
              key={option.id}
              onClick={this.onRangeRadioContainerClicked(option.id)}
            >
              <RangeRadio
                name="range"
                value={option.id}
                checked={answer === option.id}
              />
              <span>{option.label}</span>
            </RangeRadioContainer>
          ))}
        </Ranges>

        <Difficulty>
          <Label>{question.leftLabel}</Label>
          <Label>{question.rightLabel}</Label>
        </Difficulty>

        <Instructions>
          Verbally explain why you selected that answer.
        </Instructions>
      </Container>
    );
  }
}

RangeQuestionType.propTypes = {
  question: PropTypes.shape({
    label: PropTypes.string,
    rightLabel: PropTypes.string,
    leftLabel: PropTypes.string,
    questionOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
    })),
    id: PropTypes.string,
  }).isRequired,
  onQuestionAnswered: PropTypes.func.isRequired,
};

export default RangeQuestionType;
